export const isWW = (item) => item?.type === 'waitesWireless';

export const isHardware = (item) =>
  isWW(item) && ['gateway', 'node', 'router'].indexOf(item?.equipment_type || item.equipmentType) !== -1;
